import { render, staticRenderFns } from "./RestrictedSoftwareModify.vue?vue&type=template&id=7ea9c701&"
import script from "@/scripts/modal/systemManager/restrictedSoftware/restrictedSoftwareModify.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/systemManager/restrictedSoftware/restrictedSoftwareModify.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports